import { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const THeadTR: FC<Props> = ({ children }) => {
  return <tr>{children}</tr>;
};
